import { Flags } from "@/feature/pages/Flags";
import { FlagViewDTO } from "@reflag/shared/flagViewAPI";

import { useSelectedFeatureView } from "../hooks/useSelectedFeatureView";

export default function Features() {
  const [view] = useSelectedFeatureView();
  // Cast to FlagViewDTO - the types are compatible at runtime
  return view && <Flags key={view.id} view={view as unknown as FlagViewDTO} />;
}
